import React, { Fragment } from 'react';
import './investors.css';
import goup from '../../images/investors/goup.svg';
import ai from '../../images/investors/ai.svg';

const InvestMiddle = ({ isMobile }) => {
  return (
    <div className='mid-container'>

      <div className="grey-box">
        <div className="text-box">
          <div className="text-title">
          Target TAM for Autzu by 2030
          </div>
          <div className="text-content">
            The for-hire vehicle market has estimated 66.24 million
            vehicles worldwide. UBS projects a TAM for autonomous FHV
            (RoboTaxi) services of $1.161 trillion by 2030, with
            additional markets: fleet management ($188 billion), in-car
            time monetization ($472 billion), and AV Operating Systems
            ($50 billion).
          </div>
        </div>
        <div className="big-blue">
            $1.871<span className="small-blue">T</span>
        </div>
      </div>
      
      <div className="white-box">
        <div className="text-box">
          <div className="text-title">
            Automotive Market Dynamics & Growth
          </div>
          <div className="text-content">
            The mobility industry is transitioning rapidly to EVs and
            autonomous FHVs, fueled by core changes in the automotive
            landscape, growing rideshare services, environmental mandates,
            and technology advancements. This global trend presents vast
            opportunities.
            <br />
            <br />
              The introduction of new technologies have sparked an
              unprecedented growth in the mobility segment.
          </div>
        </div>
        <img src={goup} className="middle-img"></img>
      </div>

      <div className="grey-box">
        <div className="text-box">
          <div className="text-title">
          Cummulative Revenue To-Date
          </div>
          <div className="text-content">
          Our innovative model generates an impressive $48,341.89 annual revenue per vehicle
          (4x traditional car rentals). To-date we have generated $32MM in cumulative revenue
          and received more than 33,000 driver signups
          </div>
        </div>
        <div className="big-blue">
            $32<span className="small-blue">MM</span>
        </div>
      </div>

      <div className="white-box">
        <div className='text-box'>
          <div className="text-title">Automation Efficiency with Technology and AI</div>
          <div className="text-content">
            Autzu is uniquely positioned in the mobility landscape with a
            specialized focus on developing infrastructure and collecting
            data crucial for autonomous vehicle control and utilization.
            <br />
            <br />
              This commitment to technology and data-driven solutions
              significantly reduces manual operating costs and enhances our
              ability to adapt quickly to the evolving demands of
              autonomous transportation.
          </div>
        </div>
        <img src={ai} className="middle-img"></img>

      </div>
    </div>
  );
};

export default InvestMiddle;



// WEBPACK FOOTER //
// ./src/components/Investors/InvestMiddle.js